import AOS from "aos";
import React, { useEffect, useState } from "react";
import "./hoverCard.css";
import cart1 from "../../assets/img/cart/parlour.PNG";
import cart2 from "../../assets/img/cart/cart2.JPEG";
import cart3 from "../../assets/img/cart/cart3.JPEG";
import cart4 from "../../assets/img/cart/cart4.JPEG";
import cart5 from "../../assets/img/cart/IMG_0041.JPEG";
import cart6 from "../../assets/img/cart/cart6.JPEG";
import cart7 from "../../assets/img/cart/cart7.JPEG";
import cart8 from "../../assets/img/cart/cart8.JPEG";
import cart9 from "../../assets/img/cart/cart9.JPEG";
import cart10 from "../../assets/img/cart/cart10.JPEG";
import rickshaw from "../../assets/img/cart/IMG_0248.PNG";
import { useNavigate } from "react-router-dom";

const cardData = [
  {
    id: 1,
    title: "PARLOUR ON WHEELS",
    image: cart1,
    link: "/parlour-on-wheels",
    desc: "For this category, only a deep freezer with a glass top is required. The remaining items will be provided by Cart Studio.",
  },
  {
    id: 2,
    title: "TRICYLE CARTS/ PUSH CART",
    image: cart5,
    link: "/tricycle-carts",
    desc: "In the category of freezer transportation solutions, these products are designed to accommodate and safely move 120-liter to 200-liter freezers equipped with wheels.",
  },
  {
    id: 3,
    title: "E-CARTS / E RCIKSHAW",
    image: rickshaw,
    link: "/e-carts",
    desc: "With the realm of electric transportation options, these carts are specifically designed to cover distances of up to 100 kilometers while accommoda ng storage capaci es ranging",
  },

  // Add more items if needed
];

const Category = () => {
  const [visibleCount, setVisibleCount] = useState(6);
  const navigate = useNavigate();

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 6);
  };
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);
  return (
    <div id="mission" className="pb-12" data-aos="fade-up" data-aos-delay="100">
      <div className="container">
        {/* Attractive Header */}
        <div className="text-center mb-12" data-aos="fade-up">
           <span className="subtitle block mb-2 text-sm uppercase tracking-widest text-[#c85716] font-semibold">Explore Our Range</span>
           <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Premium <span className="text-[#c85716]">Categories</span></h2>
           <div className="w-20 h-1 bg-[#c85716] mx-auto rounded-full mt-2"></div>
         </div>

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {cardData.slice(0, visibleCount).map((card) => (
            <div
              onClick={() => navigate(card?.link)}
              className="col group cursor-pointer"
              key={card.id}
            >
              <div className="card h-100 border-0 shadow-sm overflow-hidden transition-all duration-300 transform hover:-translate-y-2 hover:shadow-xl rounded-2xl bg-white">
                <div
                  className="position-relative overflow-hidden bg-white"
                  style={{ height: "400px" }}
                >
                  <img
                    src={card.image}
                    className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-110"
                    alt={card.title}
                  />
                  
                  {/* Title Overlay at bottom */}
                  <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-gray-900 via-gray-900/80 to-transparent pt-12 pb-6 px-4">
                    <h5 className="text-white text-center text-lg font-bold tracking-wide uppercase mb-0">
                      {card.title}
                    </h5>
                  </div>

                  {/* Glassmorphism View Details on Hover */}
                  <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center pb-16">
                    <span className="bg-white/20 backdrop-blur-md text-white px-6 py-2 rounded-full border border-white/30 font-medium">View Details</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* {visibleCount < cardData.length && (
        <div className="text-center mt-4">
          <button
            onClick={handleShowMore}
            className="btn btn-dark px-4 py-2 text-uppercase fw-bold"
          >
            Show More
          </button>
        </div>
      )} */}
    </div>
  );
};

export default Category;
